export const LIMITS: { [key: string]: { min: string; max: string } } = {
  hours: {
    min: "1",
    max: "24",
  },
  days: {
    min: "1",
    max: "30",
  },
  weeks: {
    min: "1",
    max: "14",
  },
  months: {
    min: "1",
    max: "12",
  },
  "one-time": {
    min: "1",
    max: "1",
  },
};
